module.exports = __webpack_public_path__ + "static/media/tech-blog.888d03af.jpg";